import _ from 'lodash';

import {
  OverallOrderStatusName,
  QueryOrdersFilterInput,
  useTransactionListActivity_OrderListTabLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';
import { DateTime } from 'luxon';
import Big from 'big.js';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface IOrder {
  id: string;
  orderStatusName: OverallOrderStatusName;
  orderStatusDisplayName: string;
  orderDate: DateTime;
  orderNumber: string;

  customerFullName: string;
  customerEmail: string;
  orderTotalDollars: Big;
  requestedShippingService: string;
}

export interface IData {
  orders: IOrder[];
}

export function useQuery(storeId: string) {
  return useListQuery({
    useLazyQuery: useTransactionListActivity_OrderListTabLazyQuery,

    genFilter2GqlFilter: () => _.partial(__filter2GqlFilter, storeId),
    defaultFilterArgs: {},
    clientColumn2GqlSortField: {},
    initQuerySort: {
      columnId: 'orderDate',
      direction: 'descending'
    },
    gqlResultData2GqlPageInfo: gqlResultData =>
      gqlResultData?.orders.pageInfo,

    gqlResultData2TupleData: (gqlTuple): IData => {
      const orders = _.map(gqlTuple.data?.orders.nodes ?? [], (order): IOrder => ({
        id: order.id,
        orderStatusName: order.overallOrderStatus.name,
        orderStatusDisplayName: order.overallOrderStatus.displayName,
        orderDate: DateTime.fromISO(order.orderDate),
        orderNumber: order.orderNumber,
        customerEmail: order.customer.email,
        customerFullName: `${order.customer.firstName} ${order.customer.lastName}`,
        orderTotalDollars: new Big(order.totalCents).div(100),
        requestedShippingService: order.requestedShippingService
      }));
      const data: IData = {
        orders
      };
      return data;
    }
  });
}



function __filter2GqlFilter(storeId: string, filter?: types.IFilter): QueryOrdersFilterInput {
  return {
    storeId,
    after: filter?.after ? DateTime.fromJSDate(filter.after).toISO() : undefined,
    before: filter?.before ? DateTime.fromJSDate(filter.before).toISO() : undefined,
    omniFreeText: filter?.freeText
  };
}
